import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getRecentCommentsByAll,
  getTodayComments,
} from "../actions/userAction";
import moment from "moment";

export default function SelfTodayComments(props) {
  const dispatch = useDispatch();
  const guestCrm = JSON.parse(localStorage.getItem("guestCrm"));
  const { loading, error } = useSelector((state) => state.guestTodayComments);

  return (
    <>
      {loading ? (
        <>Loading ...</>
      ) : (
        <>
          {error ? (
            <>{error}</>
          ) : (
            <>
              {props.todayComments ? (
                <>
                  {props.todayComments.map((record) => (
                    <div className="card-body" key={record.Id}>
                      <div className="comment-content bg-white p-2">
                        <div className="d-flex flex-row user-info">
                          <img
                            className="rounded-circle"
                            src="assets/img/Deafult-user.png"
                            alt=""
                            width="40"
                          />
                          <div className="d-flex flex-column justify-content-start ml-2">
                            <span className="d-block font-weight-bold name">
                              {guestCrm
                                ? record?.First_Name
                                : record.Guest_Name}
                            </span>
                            <span className="date text-black-50">
                              {record.Institute} -{" "}
                              {moment(record.Created_On).format()}
                            </span>
                          </div>
                        </div>
                        <div className="mt-2">
                          <p className="comment-text">{record.Comment}</p>
                          <div style={{display:"flex",justifyContent:"flex-end"}}>
                            {record?.Contact_Type ? (
                              <p className="contact_t">
                                {record?.Contact_Type}
                              </p>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </>
              ) : (
                <></>
              )}
            </>
          )}
        </>
      )}
    </>
  );
}
